module.exports = __webpack_public_path__ + "img/22.5a138f4e.png";